// Description: Sales Track Card
// Update: 29/08/2025

import React from "react";
import { Box, Grid, Typography, Tooltip } from "@mui/material";
import StatusIcon from "../StatusLabel/StatusIcon";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

const CreateCardListG = ({
  title,
  subtitle,
  text,
  icon,
  iconColor,
  handleClick,
  alreadyPaid,
  heightIcon,
  type,
  status = "active",
  showText,
}) => {
  const iconSize = heightIcon ? heightIcon : "44px";
  const isEnabled = alreadyPaid && status === "active";
  const isPaid =
    typeof alreadyPaid === "function" ? alreadyPaid() : alreadyPaid;

  return (
    <Tooltip
      title={
        isEnabled ? null : (
          <Typography variant="body2">
            {status === "active"
              ? "Essa funcionalidade não está disponível no seu plano. Entre em contato com o suporte para mais informações."
              : "ERP indisponível no momento."}
          </Typography>
        )
      }
      arrow
      placement="top"
    >
      <Grid
        item
        xs={12}
        lg={12}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: { xs: "100%", sm: "280px" },
          padding: "24px",
          border: "1px solid #E0E0E0",
          borderRadius: "20px",
          background: "#fff",
          boxShadow: "0 5px 10px rgba(33, 89, 255, 0.15)",
          position: "relative",
          minHeight: "260px",
          cursor: isEnabled ? "pointer" : "not-allowed",
        }}
        onClick={isEnabled ? handleClick : null}
      >
        {/* Ícone */}
        {String(icon).startsWith("https://") ? (
          <Box
            component="img"
            src={icon}
            alt=""
            sx={{
              width: iconSize,
              height: iconSize,
              borderRadius: "12px",
              mb: "16px",
              margin: "0px"
            }}
          />
        ) : (
          <StatusIcon
            status={icon}
            color={iconColor}
            height={iconSize}
            width={iconSize}
            style={{ marginBottom: "16px" }}
          />
        )}

        {/* Título */}
        <Typography
          variant="h6"
          component="h3"
          sx={{
            fontSize: { xs: 20, sm: 22 },
            fontWeight: 800,
            color: "#0f172a",
            lineHeight: 1.1,
            mt: "20px",
          }}
        >
          {title}
        </Typography>

        {/* Subtítulo (condicional) */}
        {subtitle && (
          <Typography
            sx={{
              fontSize: 14,
              letterSpacing: "2px",
              color: "#5F1BBC",
              mt: "6px",
            }}
          >
            {subtitle}
          </Typography>
        )}

        {/* Texto (condicional) */}
        {showText && (
          <Typography
            sx={{
              fontSize: 12,
              lineHeight: "18px",
              color: "#555",
              mt: "12px",
            }}
          >
            {text}
          </Typography>
        )}

        {/* Status Label (canto superior direito, apenas se type = channel e pago != null) */}
        {type === "channel" && isPaid !== null && (
          <Box
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <Tooltip
              title={
                icon === "Email" || icon === "SMS" ? (
                  <Typography variant="body2">
                    As campanhas utilizando essa funcionalidade são liberadas
                    pela nossa equipe sob demanda. Entre em contato para saber
                    mais.
                  </Typography>
                ) : isEnabled ? (
                  <Typography variant="body2">
                    Essa funcionalidade está disponível em seu plano. Consulte a
                    documentação para saber sobre os custos.
                  </Typography>
                ) : null
              }
              arrow
              placement="top"
            >
              <Chip
                label={
                  icon === "Email" || icon === "SMS"
                    ? "Sob consulta"
                    : status === "active"
                    ? "Habilitado"
                    : "Desabilitado"
                }
                sx={{
                  backgroundColor:
                    icon === "Email" || icon === "SMS"
                      ? "#ffcbb3"
                      : status === "active"
                      ? "#D3EAC8"
                      : status === "inactive"
                      ? "#9e9e9e"
                      : "#EAD3C8",
                  color: "#fff",
                  fontWeight: 600,
                  px: 1.5,
                  py: 1.5,
                  borderRadius: "12px",
                }}
              />
            </Tooltip>
          </Box>
        )}
      </Grid>
    </Tooltip>
  );
};

export default CreateCardListG;
